import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Typography } from "@mui/material";
import frameImg from "../images/frame.svg";
import useStyles from "../css/subscriptionPlanStyle.js";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


export default function Home() {
    const classes = useStyles;  // Use the styles

    function createData(
        Name,
        Icon
    ) {
        return { Name, Icon };
    }

    const getIcon = (isActive) => (
        <CheckCircleIcon sx={{ color: isActive ? '#0D8B5A' : 'transparent' }} />
    );

    const rows = [
        createData('Business Details', getIcon(true)),
        createData('ContactDetails(Address,Phone,Email & Website)', getIcon(true)),
        createData('Set Opening Hours', getIcon(true)),
        createData('Business Description', getIcon(true)),
        createData('Add Logo & Slogan', getIcon(true)),
        createData('Add 10 FAQ', getIcon(true)),
        createData('Get Reviews & Rating', getIcon(true)),
        createData('Add All Social Contacts Include', getIcon(true)),
        createData('Add Photo ', getIcon(true)),
        createData('Add Discount Vouchers', getIcon(true)),
    ]

    const advanceRows = [
        createData('Business Details', getIcon(true)),
        createData('ContactDetails(Address,Phone,Email & Website)', getIcon(true)),
        createData('Set Opening Hours', getIcon(true)),
        createData('Business Description', getIcon(true)),
        createData('Add Logo & Slogan', getIcon(true)),
        createData('Add 10 FAQ', getIcon(true)),
        createData('Get Reviews & Rating', getIcon(true)),
        createData('Add All Social Contacts Include', getIcon(true)),
        createData('Add Photo ', getIcon(true)),
        createData('Add Discount Vouchers', getIcon(true)),
        createData('Set Promotional Ads', getIcon(true)),
        createData('Top Priority Listing in Searches', getIcon(true)),
        createData('Add 25 FAQ', getIcon(true)),
    ]

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={classes.container} // Apply container styles
        >
            <Box id="Pricing"
                sx={{
                    ...classes.headerBox,
                    backgroundImage: `url(${frameImg})` // Set background image inline
                }}
            >
                <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Grid item lg={8} md={9} sm={10} xs={11}>
                        <Typography variant="h3" sx={classes.headerTextTitle}>
                            All Subscription Plans
                        </Typography>
                        <Typography variant="body1" sx={classes.headerText}>
                            Business owners can now place job ads in AMBD to find and hire skilled and talented muslims and muslimah’s around Australia
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            <Typography sx={classes.ambdLinkText}>
                All Subscription Plans: {' '}
                <a 
                    href="https://biz.ambd.info/" 
                    style={{ color: '#009CFF' }} 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    https://biz.ambd.info/login
                </a>
            </Typography>


            <Grid
                container
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 4 }}
            >
                <Grid container item lg={10} md={10} sm={12} xs={12} spacing={5}>
                    <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={classes.subscriptionBox}>
                            <Box sx={classes.boxHeader}>
                                <Typography sx={classes.boxHeaderText}>AMBD Basic Subscription</Typography>
                            </Box>
                            <Box sx={{ p: 2, flexGrow: 1, pt: 3 }}>
                                {rows.map((row) => (
                                    <Box sx={classes.boxBody} key={row.Name}>
                                        <Typography sx={classes.boxBodyText}>{row.Name}</Typography>
                                        {row.Icon}
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ mt: 'auto', px: 2 }}>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>Monthly Package</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>
                                            $4.99 <span style={{ fontSize: '12px', fontFamily: '600' }}>/ Month</span>
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>Yearly Package</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>
                                            $49.99 <span style={{ fontSize: '12px', fontFamily: '600' }}>/ Year</span>
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, }}>
                                    <Box sx={classes.pkgBtn}>
                                        <Typography sx={classes.pkgBtnText}>Subscribe</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={classes.subscriptionBox}>
                            <Box sx={classes.boxHeader}>
                                <Typography sx={classes.boxHeaderText}>AMBD Advance Subscription</Typography>
                            </Box>
                            <Box sx={{ p: 2, flexGrow: 1, pt: 3 }}>
                                {advanceRows.map((row) => (
                                    <Box sx={classes.boxBody} key={row.Name}>
                                        <Typography sx={classes.boxBodyText}>{row.Name}</Typography>
                                        {row.Icon}
                                    </Box>
                                ))}
                                
                            </Box>
                            <Box sx={{ mt: 'auto', px: 2 }}>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>Monthly Package</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>
                                            $29.99 <span style={{ fontSize: '12px', fontFamily: '600' }}>/ Month</span>
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>Yearly Package</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>
                                            $299.99 <span style={{ fontSize: '12px', fontFamily: '600' }}>/ Year</span>
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, }}>
                                    <Box sx={classes.pkgBtn}>
                                        <Typography sx={classes.pkgBtnText}>Subscribe</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={classes.subscriptionBox}>
                            <Box sx={classes.boxHeader}>
                                <Typography sx={classes.boxHeaderText}>AMBD Business is Hiring</Typography>
                            </Box>
                            <Box sx={{ p: 2, flexGrow: 1, pt: 5 }}>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>1 Month Package</Typography>
                                        <Typography sx={classes.jobNo}>1 Job Ad</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>$9.99</Typography>
                                    </Box>
                                </Box>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>3 Month Package</Typography>
                                        <Typography sx={classes.jobNo}>3 Job Ad</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>$19.99</Typography>
                                    </Box>
                                </Box>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>6 Month Package</Typography>
                                        <Typography sx={classes.jobNo}>6 Job Ad</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>$29.99</Typography>
                                    </Box>
                                </Box>
                                <Box sx={classes.pkgBox}>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>12 Month Package</Typography>
                                        <Typography sx={classes.jobNo}>12 Job Ad</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={classes.pkgTitle}>$49.99</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ mt: 'auto', px: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, }}>
                                    <Box sx={classes.pkgBtn}>
                                        <Typography sx={classes.pkgBtnText}>Subscribe</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Grid item lg={6} md={7} sm={10} xs={11}>
                    <Typography variant="body1" sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '500', color: 'black', textAlign: 'center' }}>
                        Unless you cancel at least 24 hours before the end of the month, your account will be automatically charged for next month subscription.                    
                    </Typography>
                </Grid>
            </Grid>

        </Container>
    );
}